import axios from "axios";

// If the site is opened on the www / bare variant of the backend's domain, call the API on
// the same origin — a cross-origin call through a domain redirect fails in the browser.
function resolveBackend() {
  const configured = process.env.REACT_APP_BACKEND_URL;
  try {
    const cfg = new URL(configured);
    const here = window.location;
    const strip = (h) => h.replace(/^www\./, "");
    if (here.host !== cfg.host && strip(here.hostname) === strip(cfg.hostname)) return here.origin;
  } catch (e) { /* fall through */ }
  return configured;
}
export const BACKEND_URL = resolveBackend();
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("volmee_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
